import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ChevronLeft, ChevronRight } from "lucide-react";

import { AUDIT_PER_PAGE_OPTIONS } from "../constants";
import { AUDIT_LABELS } from "../messages";

interface AuditPaginationProps {
  total: number;
  perPage: number;
  currentPage: number;
  lastPage: number;
  hasPrevious: boolean;
  hasNext: boolean;
  onPerPageChange: (perPage: number) => void;
  onPrevious: () => void;
  onNext: () => void;
}

export function AuditPagination({
  total,
  perPage,
  currentPage,
  lastPage,
  hasPrevious,
  hasNext,
  onPerPageChange,
  onPrevious,
  onNext,
}: AuditPaginationProps): JSX.Element {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-2">
      <div className="flex-1 text-sm text-muted-foreground">
        {AUDIT_LABELS.TOTAL(total)}
      </div>

      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2">
          <p className="text-sm font-medium">{AUDIT_LABELS.ROWS_PER_PAGE}</p>
          <Select
            value={`${perPage}`}
            onValueChange={(value: string) => onPerPageChange(Number(value))}
          >
            <SelectTrigger className="h-8 w-[72px]">
              <SelectValue placeholder={`${perPage}`} />
            </SelectTrigger>
            <SelectContent side="top">
              {AUDIT_PER_PAGE_OPTIONS.map((option: number) => (
                <SelectItem key={option} value={`${option}`}>
                  {option}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">
            {AUDIT_LABELS.PAGE_OF(currentPage, lastPage)}
          </span>
          <Button
            variant="outline"
            className="h-8 w-8 p-0"
            aria-label={AUDIT_LABELS.PREVIOUS_PAGE}
            disabled={!hasPrevious}
            onClick={onPrevious}
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <Button
            variant="outline"
            className="h-8 w-8 p-0"
            aria-label={AUDIT_LABELS.NEXT_PAGE}
            disabled={!hasNext}
            onClick={onNext}
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
